var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32046 8.77476C5.88921 8.34427 5.62671 7.75927 5.62671 7.10302C5.62671 5.78827 6.68571 4.72852 7.99971 4.72852C8.64996 4.72852 9.24846 4.99177 9.67221 5.42227",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3286 7.52393C10.1546 8.49143 9.39262 9.25493 8.42587 9.43043",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99096 11.104C2.80071 10.1695 1.79271 8.80449 1.06221 7.10274C1.80021 5.39349 2.81496 4.02099 4.01271 3.07899C5.20296 2.13699 6.57621 1.62549 7.99971 1.62549C9.43146 1.62549 10.804 2.14449 12.0017 3.09324",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5857 4.74268C14.1017 5.42818 14.5555 6.21943 14.9372 7.10218C13.462 10.5199 10.855 12.5787 7.99971 12.5787C7.35246 12.5787 6.71421 12.4737 6.10071 12.2689",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9153 1.18701L2.08476 13.0175",
    stroke: "#7B6F72",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.acf20c7bdd3e2377cfc5a0a0a23d6054.svg";
export { ForwardRef as ReactComponent };